__turbopack_context__.v({
  "item": "wave-module__pt61wG__item",
  "wave": "wave-module__pt61wG__wave",
  "wrapper": "wave-module__pt61wG__wrapper",
});
